import { EnvironmentProviders, Provider } from '@angular/core';
import { provideModuleWidgets, SOFTLINE_WIDGET_OUTLET_DASHBOARD } from '@softapps/core';
import {
  SOFTLINE_PERMISSION_PMS_ARBEITSBERICHT_STATISTIK_STUNDEN_UEBERSICHT_WIDGET,
  SOFTLINE_PERMISSION_PMS_ARBEITSBERICHT_STATISTIK_TICKET_UEBERSICHT_WIDGET,
} from '../arbeitsbericht-statistik.shared';

export const arbeitsberichtStatistikWidgetProviders: (
  | Provider
  | EnvironmentProviders
)[] = provideModuleWidgets([
  {
    outletNames: [SOFTLINE_WIDGET_OUTLET_DASHBOARD],
    group: 'pms',
    loadComponent: () =>
      import('./work-hours-chart-widget/work-hours-chart-widget.component').then(
        (m) => m.WorkHoursChartWidgetComponent
      ),
    permission:
      SOFTLINE_PERMISSION_PMS_ARBEITSBERICHT_STATISTIK_STUNDEN_UEBERSICHT_WIDGET,
  },
  {
    outletNames: [SOFTLINE_WIDGET_OUTLET_DASHBOARD],
    group: 'pms',
    loadComponent: () =>
      import('./ticket-widget/ticket-widget.component').then(
        (m) => m.TicketWidgetComponent
      ),
    permission:
      SOFTLINE_PERMISSION_PMS_ARBEITSBERICHT_STATISTIK_TICKET_UEBERSICHT_WIDGET,
  },
]);
